import React from 'react';
import { Link } from 'react-router-dom';
import { Camera, CreditCard, ShieldCheck } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-white py-8 md:py-12 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-6 md:gap-0">
          <div className="flex items-center gap-2">
            <Camera className="w-5 h-5 md:w-6 md:h-6" />
            <span className="font-semibold text-lg">OurPhotos</span>
          </div>
          
          <nav className="flex flex-col md:flex-row gap-4 md:gap-8 text-gray-600">
            <Link to="/features" className="hover:text-gray-900 transition-colors">Features</Link>
            <Link to="/pricing" className="hover:text-gray-900 transition-colors">Pricing</Link>
            <Link to="/terms" className="hover:text-gray-900 transition-colors">Terms</Link>
            <Link to="/privacy" className="hover:text-gray-900 transition-colors">Privacy</Link>
          </nav>
          
          <div className="text-gray-500 text-sm md:text-base order-first md:order-last mb-4 md:mb-0">
            © 2024 GLASIR SOFTWARE
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-100 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center text-sm text-gray-500">
            <ShieldCheck className="w-4 h-4 mr-1.5 text-green-500" />
            <span>Secure payment processing by</span>
            <a 
              href="https://stripe.com" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="ml-2"
            >
              <img 
                src="https://static.cdnlogo.com/logos/s/83/stripe.svg" 
                alt="Stripe" 
                className="h-8 md:h-10" 
              />
            </a>
          </div>

          <div className="flex items-center text-sm text-gray-500">
            <CreditCard className="w-4 h-4 mr-1.5" />
            <span>We accept all major credit cards</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;